import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { Header } from "@website/widget/login/components";
import { usePasswordCard } from "@website/widget/login/components/password-card/password-card.hook";
import styles from "@website/widget/login/components/password-card/password-card.module.scss";
import { PasswordCardPropertiesType } from "@website/widget/login/components/password-card/password-card.types";
import { PasswordField } from "@website/widget/password-field";
import { FC } from "react";
export const PasswordCard: FC<PasswordCardPropertiesType> = properties => {
  const $ = _c(35);
  const {
    onClose
  } = properties;
  const {
    error,
    password,
    onChangePassword,
    onSubmitPassword,
    onOtpClick,
    isLoadingPassword,
    isLoadingOtp,
    onClickForgotPassword,
    onBackClick
  } = usePasswordCard(properties);
  let t0;
  if ($[0] !== onBackClick || $[1] !== onClose) {
    t0 = <Header onBack={onBackClick} onClose={onClose} title={"\u0648\u0627\u0631\u062F \u06A9\u0631\u062F\u0646 \u0631\u0645\u0632 \u0639\u0628\u0648\u0631"} />;
    $[0] = onBackClick;
    $[1] = onClose;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = isLoadingPassword || isLoadingOtp ? undefined : onSubmitPassword;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.title}>لطفا رمز عبور خود را وارد کنید.</div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = Boolean(error);
  let t4;
  if ($[4] !== error || $[5] !== onChangePassword || $[6] !== password || $[7] !== t3) {
    t4 = <div className={styles.input}><PasswordField error={t3} fullWidth={true} helperText={error} hideConditions={true} initialValue={password} onChange={onChangePassword} placeholder={"\u0631\u0645\u0632 \u0639\u0628\u0648\u0631"} autoFocus={true} /></div>;
    $[4] = error;
    $[5] = onChangePassword;
    $[6] = password;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onClickForgotPassword) {
    t5 = <div className={styles.info}>رمز عبور خود را فراموش کرده ام.<Button color="secondary" onClick={onClickForgotPassword} size="small" type="button" variant="text">بازیابی رمز عبور</Button></div>;
    $[9] = onClickForgotPassword;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isLoadingPassword) {
    t6 = isLoadingPassword ? <Loading color="white" size="lg" /> : replaceSnappTripBasedOnChannel("\u062A\u0627\u06CC\u06CC\u062F \u0648 \u0648\u0631\u0648\u062F \u0628\u0647 \u0627\u0633\u0646\u067E\u200C\u062A\u0631\u06CC\u067E!");
    $[11] = isLoadingPassword;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isLoadingOtp || $[14] !== t6) {
    t7 = <Button color="secondary" disabled={isLoadingOtp} fullWidth={true} size="large" type="submit" variant="contained">{t6}</Button>;
    $[13] = isLoadingOtp;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = isLoadingOtp || isLoadingPassword ? undefined : onOtpClick;
  let t9;
  if ($[16] !== isLoadingOtp) {
    t9 = isLoadingOtp ? <Loading color="secondary" size="lg" /> : "\u0648\u0631\u0648\u062F \u0628\u0627 \u06A9\u062F \u06CC\u06A9\u0628\u0627\u0631 \u0645\u0635\u0631\u0641";
    $[16] = isLoadingOtp;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isLoadingPassword || $[19] !== t8 || $[20] !== t9) {
    t10 = <Button color="secondary" disabled={isLoadingPassword} fullWidth={true} onClick={t8} size="large" type="button" variant="outline">{t9}</Button>;
    $[18] = isLoadingPassword;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <MaterialIcon name="support_agent" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Button StartIcon={t11} color="secondary" fullWidth={true} href="tel:+982192000123" role="link" size="large" type="button" variant="text">تماس با پشتیبانی ({numberConvert("02192000123", {
        locale: "fa"
      })})</Button>;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t7) {
    t13 = <div className={styles.footer}>{t7}{t10}{t12}</div>;
    $[24] = t10;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t1 || $[28] !== t13 || $[29] !== t4 || $[30] !== t5) {
    t14 = <form className="w-full" onSubmit={t1}>{t2}{t4}{t5}{t13}</form>;
    $[27] = t1;
    $[28] = t13;
    $[29] = t4;
    $[30] = t5;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t0 || $[33] !== t14) {
    t15 = <div className={styles.container}>{t0}{t14}</div>;
    $[32] = t0;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};